export const parseDateOnly = (dateString) => {
  if (!dateString) return null;

  if (dateString instanceof Date) {
    return {
      year: dateString.getUTCFullYear(),
      month: dateString.getUTCMonth(),
      day: dateString.getUTCDate()
    };
  }

  const dateStr = typeof dateString === 'string' ? dateString.split('T')[0] : String(dateString);
  const parts = dateStr.split('-');
  if (parts.length === 3) {
    return {
      year: parseInt(parts[0], 10),
      month: parseInt(parts[1], 10) - 1,
      day: parseInt(parts[2], 10)
    };
  }

  const d = new Date(dateString);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth(),
    day: d.getUTCDate()
  };
};

export const getCourseTimelineStatus = (course) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const startDateParts = parseDateOnly(course.start_date);
  const endDateParts = parseDateOnly(course.end_date);

  const courseStartDate = startDateParts
    ? new Date(startDateParts.year, startDateParts.month, startDateParts.day)
    : null;
  const courseEndDate = endDateParts
    ? new Date(endDateParts.year, endDateParts.month, endDateParts.day)
    : null;

  return {
    hasStarted: !courseStartDate || courseStartDate <= today,
    hasEnded: Boolean(courseEndDate && courseEndDate < today)
  };
};

export const formatCourseDate = (course) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  if (!course.start_date) {
    return 'TBD';
  }

  const startDateParts = parseDateOnly(course.start_date);
  const courseStartDate = new Date(startDateParts.year, startDateParts.month, startDateParts.day);

  // Format date using the parsed parts directly
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const formattedStartDate = `${monthNames[startDateParts.month]} ${startDateParts.day}${startDateParts.year !== now.getFullYear() ? `, ${startDateParts.year}` : ''}`;

  // Check if course has ended
  let hasEnded = false;
  let formattedEndDate = '';

  if (course.end_date) {
    const endDateParts = parseDateOnly(course.end_date);
    const courseEndDate = new Date(endDateParts.year, endDateParts.month, endDateParts.day);
    hasEnded = courseEndDate < today;
    formattedEndDate = `${monthNames[endDateParts.month]} ${endDateParts.day}${endDateParts.year !== now.getFullYear() ? `, ${endDateParts.year}` : ''}`;
  }

  // Determine course status
  const hasStarted = courseStartDate <= today;

  if (hasEnded) {
    // Course has ended
    return `Started: ${formattedStartDate} - Ended: ${formattedEndDate}`;
  } else if (hasStarted) {
    // Course has started but not ended
    return `Started: ${formattedStartDate} - Ends: ${formattedEndDate}`;
  } else {
    // Course has not started yet
    return `Starts: ${formattedStartDate} - Ends: ${formattedEndDate}`;
  }
};
